import React from 'react';
import { Price } from 'fronton-react';
import { useTranslation } from 'react-i18next';
import { SetProduct } from 'features/product-info/types';

export const DATA_QA_SET_HIDDEN_PRODUCT_LIST = 'set-hidden-product-list';

export type Props = {
  products: SetProduct[];
};

export function HiddentProductList({ products }: Props) {
  const { t } = useTranslation();

  return (
    <div hidden data-qa={DATA_QA_SET_HIDDEN_PRODUCT_LIST}>
      {products.map(({ productId, quantity, data: { displayedName, price, productPageName } }) => {
        const currentPrice = quantity > 1 ? price.main_price * quantity : price.main_price;
        const plenty = quantity > 1 ? `${quantity} ${price.main_uom_rus} по` : '';

        return (
          <div key={productId}>
            <span>
              {t('product-card.product-id')} {productId}
            </span>
            <a href={`/product/${productPageName}/`}>{displayedName}</a>
            <Price fraction value={currentPrice} />
            {plenty && (
              <span>
                <span>{plenty}</span>
                <Price fraction value={price.main_price} />
              </span>
            )}
          </div>
        );
      })}
    </div>
  );
}
